import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

import type {
  PostAppSettingsAppGroupIdQuietHoursRulesProps,
  PostAppSettingsAppGroupIdQuietHoursRulesResult,
} from "./types";

const isWorkspaceQuietHoursRule = objectOf({
  id: string,
  channel: string,
  quiet_time_start: string,
  quiet_time_end: string,
});

const isWorkspaceQuietHoursRuleProps = objectOf({
  channel: string,
  quiet_time_start: string,
  quiet_time_end: string,
});

export const isPostAppSettingsAppGroupIdQuietHoursRulesResult =
  objectOf<PostAppSettingsAppGroupIdQuietHoursRulesResult>({
    id: string,
    rules: arrayOf(isWorkspaceQuietHoursRule),
  });

export const isPostAppSettingsAppGroupIdQuietHoursRulesProps =
  objectOf<PostAppSettingsAppGroupIdQuietHoursRulesProps>({
    appGroupId: string,
    rules: arrayOf(isWorkspaceQuietHoursRuleProps),
  });
